import React from "react";
import { Edit, SimpleForm, useTranslate, TextInput, Toolbar, SaveButton, required, DeleteButton, SelectInput } from "react-admin";
import { Typography, Box, makeStyles, CircularProgress } from '@material-ui/core';
import lightTheme from '../layout/themes';
import BackButton from '../components/BackButton';
import MyTooltip from '../components/MuiTooltip';
import '../index.css';

const useStyles = makeStyles({
    InputBlackBorder: lightTheme.InputBlackBorder,
    CardUsersEdit: lightTheme.CardUsersEdit,
    EditToolBar: lightTheme.EditToolBar,
});

const NewsCategoriesEdit = props => {
    const classes = useStyles();
    const translate = useTranslate();
    const redirect = () => `/newsCategories`;
    const TypeChoices=[ 
        { id: 'Categoría', name: 'Categoría' }, 
        { id: 'Subcategoría', name: 'Subcategoría' },
    ] 

    const NewsCategoriesEditToolbar = ({loading, ...props}) => {
        const classes = useStyles();
        const basePath = `/newsCategories`;
        return (
            <Box>
                <Toolbar {...props} style={{display: 'flex', justifyContent: 'flex-start'}} className={classes.EditToolBar}>
                    <MyTooltip title={<div style={{fontSize: '12px'}}>Guardar Cambios</div>} aria-label="Save" arrow>
                        <SaveButton disabled={props.pristine} redirect={`/newsCategories`} id="GoogleStyleSaveButton">
                        {loading && (<CircularProgress/>)}
                        </SaveButton>
                    </MyTooltip>
                    <MyTooltip title={<div style={{fontSize: '12px'}}>Eliminar Categoría</div>} aria-label="Delete" arrow placement="right">
                        <DeleteButton basePath={basePath} label="" id="GoogleStyleDeleteButton"/>
                    </MyTooltip>
                </Toolbar>
            </Box>
        )
    };

    return (
        <Edit {...props}>
            <SimpleForm redirect={redirect} toolbar={<NewsCategoriesEditToolbar/>}>
                <Box style={{ width:'100%', color: '#3d3d3d' }}>
                    <Box display="flex" p={1} style={{ width: '100%' }} justifyContent="flex-start">
                        <Box p={1} width="100%">
                            <Typography variant="h5" style={{marginBottom: '1.5vw', marginLeft: '-5px'}}>Editar Categoría</Typography>
                        </Box>
                        <Box p={1} flexShrink={0} style={{position: 'relative', top: '-15px'}}>
                            <MyTooltip title={<div style={{fontSize: '12px'}}>Cerrar</div>} aria-label="GoBack" arrow>
                                <BackButton style={{paddingLeft: '17px',  paddingRight: '5px'}}></BackButton>
                            </MyTooltip>
                        </Box>
                    </Box>
                    <Box>
                        <Box display="flex" style={{ width: '100%' }} justifyContent="flex-start">
                            <TextInput label={translate('resources.pointOfSale.field.name')} source="name" variant="outlined" 
                                multiline="true" fullWidth className={classes.InputBlackBorder} validate={required()}/>
                            <SelectInput required label="Tipo" variant="outlined" source="type"
                                multiline="true" fullWidth className={classes.InputBlackBorder} choices={TypeChoices} style={{textTransform: 'capitalize', display: 'none'}}/>
                        </Box>
                    </Box>
                </Box>
            </SimpleForm>
        </Edit>
    )
};

export default NewsCategoriesEdit;